/**
 * 가격 숫자를 한국 원화 형식 문자열로 변환합니다.
 * @param {number|string|null|undefined} amount
 * @returns {string} 예: 139000 → "139,000"
 */
export function formatPrice(amount) {
  if (amount == null || isNaN(Number(amount))) return '0';
  return Number(amount).toLocaleString('ko-KR');
}
